import React from 'react';
import { InertiaLink } from '@inertiajs/inertia-react';
import Icon from './Icon';
import classNames from 'classnames';

export default ({ link, product, onAddToCart }) =>(
     <div className="w-full">
          <div className="bg-gray-50 border border-gray-100 hover:shadow-xl hover:border-emerald-600 rounded-lg ">
               <div className="rounded-t">
                    {product.image && (<img className="rounded-t h-56 mx-auto mt-2" src={product.image} alt={product.name} />)}
                    {!product.image && (<img className="rounded-t h-56 mx-auto mt-2" src={`https://ui-avatars.com/api/?name=${product.name}&amp;color=1DAD2C&amp;background=BDD9C0`} alt={product.name} />)}
               </div>
               <div className="w-full flex px-2 pt-2">
                    <div className="w-full flex px-2">
                         <h1 className="font-medium text-md">{product.name}</h1>
                         {/*<div className="w-full text-right">
                              <div className="text-emerald-500 font-semibold text-sm font-poppins">{product.currency} {product.price.toFixed(2)}</div>
                         </div>*/}
                    </div>
               </div>
               <div className="w-full flex">
                    <div className="w-full flex px-4">
                         {product.addCart && (<div className="w-full text-right">
                              <div className={`${product.promotion?'text-gray-500 text-sm line-through':'text-emerald-400 text-md'} font-semibold font-poppins`}>{product.currency} {product.price.toFixed(2)}</div>
                              {(product.promotion > 0) && (<div className="text-emerald-500 font-semibold text-md font-poppins"><span className="text-red-600 animate-puls mr-6">{product.special_caption}</span>{product.currency} {product.promotion.toFixed(2)}</div>)}
                         </div>)}
                    </div>
               </div>
               <div className="flex justify-center items-center px-2 pb-2">
                    <div className="w-1/2 p-2">
                         <InertiaLink href={route(link, product.slug)} className="block w-full text-center bg-emerald-500 hover:bg-emerald-600 text-white border-2 border-emerald-500 hover:border-emerald-600 p-2 rounded uppercase font-poppins font-medium">
                              {product.btn_caption}
                         </InertiaLink>
                    </div>
                    <div className={`w-1/2 p-2`}>
                         {product.addCart && (<button onClick={onAddToCart} className="block w-full bg-white hover:bg-gray-200 text-emerald-500 p-2 rounded uppercase font-medium">
                              <Icon name={'shopping-cart'} className={'fill-current w-4 h-4 mx-auto m-2'} />
                         </button>)}
                         {!product.addCart && (<span className="text-xs text-yellow-600">{product.naonline}</span>)}
                    </div>
               </div>
          </div>
     </div>
);
